import { createAction } from '@reduxjs/toolkit';

export const setEasyRefillCartLoading = createAction<{ isLoadingCart: boolean }>('CART/SET_CART_EASY_REFILL_LOADING');
